import axios from 'axios';
import environmentConfig from '../config/config';
import { getMarketFiles } from './marketFiles';

// [당첨 축하 팝업 미리 받기] rewardStarted 시점에 경품 상품 정보·3D 라이브러리·glb·대표 이미지를 미리 받아 둠
// 결과 팝업까지 Transfer 처리 시간(약 20초)이 있어 그동안 받아 두면 팝업에서 바로 표시됨. 실패는 조용히 무시
// glb는 HTTP 캐시 헤더와 상관없이 쓰도록 Blob으로 보관 (팝업에서 blob URL로 표시 후 정리)
const prizeCache = new Map(); // marketNo → { prize: { name, modelUrl, imageUrl }, modelBlobPromise: Promise<Blob|null> | null }

// 마켓 상세·구매 상세 응답 → 팝업 표시용 상품 정보 (두 응답의 필드명 동일)
export const toPrize = data => {
  const files = getMarketFiles(data);
  return { name: data.marketDataName || '', modelUrl: files.modelUrl, imageUrl: files.imageUrl };
};

export const getCachedEntry = marketNo => (marketNo ? prizeCache.get(Number(marketNo)) || null : null);

export const clearCachedEntry = marketNo => {
  if (marketNo) prizeCache.delete(Number(marketNo));
};

// glb 다운로드 — 실패하면 null로 resolve (팝업은 서버 URL로 대체)
const fetchModelBlob = url =>
  fetch(url)
    .then(res => (res.ok ? res.blob() : null))
    .catch(() => null);

export const prefetchRewardPrize = async marketNo => {
  if (!marketNo) return;
  // 이미 받아 둔(또는 받는 중인) 항목이 있으면 같은 Promise를 공유 — 중복 다운로드 없음
  if (getCachedEntry(marketNo)) return;
  try {
    // 3D 라이브러리 청크 — ModelViewer와 같은 경로라 같은 청크를 재사용
    import('@google/model-viewer/dist/model-viewer.min.js').catch(() => {});

    const res = await axios.get(`${environmentConfig.apiUrl}/market/${marketNo}`, { timeout: 10000 });
    const data = res.data?.data;
    if (!data || getCachedEntry(marketNo)) return;
    const prize = toPrize(data);
    const modelBlobPromise = prize.modelUrl ? fetchModelBlob(prize.modelUrl) : null;
    prizeCache.set(Number(marketNo), { prize, modelBlobPromise });

    // 대표 이미지: <img>와 같은 요청 방식으로 미리 요청
    if (prize.imageUrl) {
      const img = new Image();
      img.src = prize.imageUrl;
    }
  } catch (e) {
    // 미리 받기 실패는 무시 — 팝업에서 기존처럼 조회
  }
};
